var React = require('react');

function NavIconSalesPound (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m5.5-352c-16.8 0-30.4 13.7-30.3 30.5l.2 33.5h40.5c8.8 0 16 7.2 16 16s-7.2 16-16 16h-40.3l.1 9.7c.1 18.6-3.1 37-9.6 54.3H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-8.4 0-16.1-4.4-20.5-11.5s-4.7-16-.8-23.5l9.6-18.6c7.7-14.9 11.6-31.5 11.5-48.3l-.1-10.1H176c-8.8 0-16-7.2-16-16s7.2-16 16-16h7.5l-.2-33.1c-.3-43.5 34.8-78.9 78.3-78.9 10 0 19.8 1.9 29.1 5.6l30.3 12.1c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4l-30.3-12.1c-3.6-1.4-7.4-2.2-11.3-2.2z"}));
}

NavIconSalesPound.defaultProps = {"viewBox":"0 0 512 512","fill":"currentColor"};

module.exports = NavIconSalesPound;

NavIconSalesPound.default = NavIconSalesPound;
